export default __webpack_public_path__ + "static/media/intro5.998585e6.mp3";